import React from 'react'
import BounceLoader from "react-spinners/BounceLoader";
import { css } from "@emotion/core";

const override = css`
  display: inline-block;
  margin: 20px;
`;

function LoadingSpinner() {
    
    return (
        <div className="block border-none border-4 content-evenly text-center mt-10">
            <div>
                <BounceLoader size={100} css={override} color='#44A3CE'/>
                {/*Look at changing the text as it searches  */}
                <p className="text-xl font-semibold">Loading...</p> 
            </div>
        </div>
    )
}

export default LoadingSpinner